import React, { SVGProps } from 'react';

export const RehearsalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.5 11.1H24v1.8h-7.5zm0-4.5v1.8H24V6.6zm0 10.8H21v-1.8h-4.5zM3.48 8.566c0-3 .33-6.15 4.396-6.15 4.064 0 4.394 3.164 4.394 6.15 0 2.984-.27 6.148-4.394 6.148-4.126 0-4.396-3.178-4.396-6.148m1.8-.002c0 3.69.674 4.35 2.594 4.35s2.626-.66 2.626-4.35-.674-4.35-2.596-4.35c-1.92 0-2.624.66-2.624 4.35m2.596 7.846c-3.616 0-5.192-1.32-5.79-4.89l-1.786.3c.706 4.11 2.79 6.076 6.676 6.346V21h1.8v-2.836c3.884-.27 6-2.234 6.674-6.344l-1.786-.3c-.6 3.57-2.174 4.89-5.788 4.89"
    />
  </svg>
);
